import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { ActivatedRouteModel } from "@modules/common/models/activated-route-model";
import { CurrentCaseService } from "@modules/common/services/current-case.service";
import { RouteModelService } from '@modules/common/services/route-model.service';

@Injectable({
    providedIn: 'root'
})
export class RedirectToLoginService {
    constructor(
        private _router: Router,
        private _currentCaseService: CurrentCaseService,
        private _routeModelService: RouteModelService
    ) { }

    private _redirectedFromUrl: any[] | undefined;
    private _queryParams: { [key: string]: string } | undefined;

    public redirectToLogin(redirectedFromRoute?: ActivatedRouteSnapshot): void {
        this._redirectedFromUrl = undefined;

        const routeModel = this.getRouteModel(redirectedFromRoute);
        const fromUrl = routeModel?.urlWithPopulatedParameters;

        //We only want to do the redirect if the page we're coming from isn't a login page, unless
        //that page is the AccountSettings page
        if (fromUrl && (fromUrl.indexOf('Login') === -1 || fromUrl.indexOf('AccountSettings') !== -1)) {
            this._redirectedFromUrl = fromUrl.slice();
            //Add an extra element to the URL containing Angular's custom query params (the ; separated parts)
            for (let k in routeModel.params) {
                if (routeModel.urlWithParameterPlaceholders.indexOf(':' + k) == -1) {
                    if (this._redirectedFromUrl.length == routeModel.urlWithParameterPlaceholders.length) {
                        this._redirectedFromUrl.push({});
                    }

                    this._redirectedFromUrl[this._redirectedFromUrl.length - 1][k] = routeModel.params[k];
                }
            }
            this._queryParams = routeModel?.queryParams;
        }

        //We only want to use the case branding for the login page
        //if the user isn't in the main Stingray site. If the user
        //is in Stingray, then we have to use Winston branding.
        if (fromUrl && fromUrl.indexOf('Login') !== -1) {
            const caseName = this._currentCaseService.getCurrentCaseName();

            if (caseName) {
                this._router.navigate(['/' + caseName + '/Login']);
                return;
            }
        }

        this._router.navigate(['/Login']);
    }

    public getRedirectedFromUrl(): any[] | undefined {
        return this._redirectedFromUrl;
    }

    public getQueryParams(): { [key: string]: string } | undefined {
        return this._queryParams;
    }

    public clearRedirectedFromUrl(): void {
        this._redirectedFromUrl = undefined;
        this._queryParams = undefined;
    }

    private getRouteModel(redirectedFromRoute?: ActivatedRouteSnapshot): ActivatedRouteModel | undefined {
        return this._routeModelService.getRouteModel(redirectedFromRoute || this._router.routerState.snapshot.root);
    }
}


